import { MTypography, OfferDocumentIcon } from 'src/lib';
import { OfferDocument } from 'src/models';
import { Color } from 'src/styles';

import * as Styles from './OfferDocumentsTab.styles';

export type OfferDocumentsTabProps = {
  offerDocuments: OfferDocument[];
};

export const OfferDocumentsTab = ({ offerDocuments }: OfferDocumentsTabProps) => {
  return (
    <div className={Styles.container}>
      {offerDocuments.map(document => (
        <a key={document.id} href={document.url} target='_blank' rel='noreferrer' className={Styles.documentLink}>
          <OfferDocumentIcon type={document.type} className={Styles.documentLogo} />
          <MTypography variant='subtitle1' color={Color.Brand5}>
            {document.label}
          </MTypography>
        </a>
      ))}
    </div>
  );
};
